





























































































































































































































































































































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { mapGetters, mapState, mapActions } from "vuex";
import { validationMixin } from "vuelidate";
import {
  required,
  requiredIf,
  minLength,
  sameAs,
} from "vuelidate/lib/validators";

import { getFieldError } from "@/core/tools/forms/get_field_error";

import { STORE_KEY as PARENT_STORE_KEY } from "../_store";
import { STORE_KEY, store } from "./_store";

@Component({
  mixins: [validationMixin],
  computed: {
    ...mapState(PARENT_STORE_KEY, ["document"]),
    ...mapState(STORE_KEY, [
      "loaded",
      "loading",
      "fatalError",
      "form",
      "formDirty",
      "remains",
      "asyncValidationLoading",
      "hasAsyncError",
      "asyncErrors",
    ]),
    ...mapGetters(STORE_KEY, ["fields"]),
  },
  methods: {
    getFieldError,
  },
  validations() {
    const rules: any = {
      name: { required, minLength: minLength(3) },
      status_id: { required },

      client_id: { required },
      type_id: { required },
      delivery_point_id: {},
      expected_delivery_date: {},
      availability_date: {},

      manager_id: {},
      payment_type_id: {},
      counterparty_id: {},
      delivery_warehouse_id: {},
      destination_warehouse_id: {},
      destination_delivery_point_id: {},
      return_type_id: {},
      deal_comment: {},
      exported_to_1c: {},
    };

    return {
      form: rules,
    };
  },
})
export default class ClientForm extends Vue {
  document!: any;
  form!: any;
  noUpdateAfterLoad: boolean = false;
  days: any[] = [];

  public created() {
    // @ts-ignore
    if (!(STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(STORE_KEY, store);
    }
  }

  public mounted() {
    console.log("mounted", this.document, this.$route.query);
    if (this.document.id) {
      this.noUpdateAfterLoad = true;
      this.$store
        .dispatch(`${STORE_KEY}/init`, {
          id: this.document.id,
        })
        .then(() => {
          setTimeout(() => {
            this.noUpdateAfterLoad = false;
          }, 5000);
        });
    } else {
      this.noUpdateAfterLoad = false;
      this.$store.dispatch(`${STORE_KEY}/prepareNew`, this.$route.query);
    }
  }

  changeValue(field: string, value: any) {
    this.$store.dispatch(`${STORE_KEY}/changeFormValue`, {
      field,
      newValue: value,
    });

    if (this.$v.form[field]) {
      // @ts-ignore
      this.$v.form[field].$touch();
    }
  }

  toggleCredentials(field: string, value: any) {
    this.$store.dispatch(`${STORE_KEY}/toggleCredentials`);

    if (this.$v.form.credentials) {
      // @ts-ignore
      this.$v.form.credentials.$touch();
    }

    // this.$v.form.$touch();
  }

  changeCredentialsValue(field: string, value: any) {
    this.$store.dispatch(`${STORE_KEY}/changeCredentialsValue`, {
      field,
      newValue: value,
    });

    // @ts-ignore
    this.$v.form.credentials[field].$touch();
    // this.$v.form.$touch();
  }

  toggleRoleSelection(roleId: string) {
    this.$store.dispatch(`${STORE_KEY}/toggleRoleSelection`, roleId);

    if (this.$v.form.roles) {
      this.$v.form.roles.$touch();
    }

    // this.$v.form.$touch();
  }

  onClientChange($event: any) {
    console.log("onClientChange", $event);
    if ($event.label) {
      this.changeValue("name", $event.label);
      this.changeValue("deal_comment", $event.deal_comment);
      this.changeValue("payment_type_id", $event.payment_type_id);
      this.changeValue("delivery_warehouse_id", $event.delivery_warehouse_id);
      this.changeValue(
        "destination_warehouse_id",
        $event.destination_warehouse_id,
      );
      this.changeValue("manager_id", $event.manager_id);
      this.changeValue("client_type_id", $event.type_id);
      this.changeValue(
        "client_special_orders",
        !!$event.special_orders
      );

      if (
        !this.form.type_id &&
        ["d:client_types:5", "d:client_types:9"].includes($event.type_id)
      ) {
        this.changeValue("type_id", "d:deals_types:4");
      }
    }
  }

  onDeliveryPointChangeAllways($event: any) {
    if ($event && $event.label) {
      const week_days: any = $event.days.filter((item: any) => {
        return item.delivery_point_id == $event.id;
      });
      $event.days = week_days.length > 0 ? week_days : $event.days;
    }
  }

  onDeliveryPointChange($event: any) {
    if ($event && $event.label) {
      this.changeValue("delivery_delay", $event.delivery_delay);
      this.changeValue("counterparty_id", $event.counterparty_id);
      const week_days: any = $event.days.filter((item: any) => {
        return item.delivery_point_id == $event.id;
      });

      this.days = (week_days.length > 0 ? week_days : $event.days).sort(
        function(a: any, b: any) {
          if (a.week_day > b.week_day) return 1;
          if (a.week_day < b.week_day) return -1;
          return 0;
        },
      );
      // if (!this.form.expected_delivery_date) {
      //   this.$store.dispatch(`${STORE_KEY}/getDeliveryDate`, {delivery_zone_id: $event.delivery_zone_id})
      // }
    }
  }
  onCounterparty($event: any) {
    if ($event && $event.label) {
      if (!this.form.delivery_point_id) {
        this.changeValue("delivery_point_id", $event.delivery_point_id);
      }
    }
  }

  saveFormData() {
    this.$v.form.$touch();

    if (!this.$v.form.$error) {
      this.$store
        .dispatch(`${STORE_KEY}/saveForm`, {
          id: this.document.id,
        })
        .then((result) => {
          this.$buefy.snackbar.open(`Данные успешно сохранены`);
          this.$v.form.$reset();

          this.$emit("on-need-data-reload", result.document.id);
        })
        .catch(() => {
          this.$buefy.snackbar.open({
            type: "is-warning",
            message: `При сохранении возникли проблемы. Попробуйте позже.`,
          });
        });
    }
  }

  beforeDestroy() {
    this.$store.dispatch(`${STORE_KEY}/reset`);
    // this.$store.unregisterModule(STORE_KEY);
  }
}
